import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface PriceChangeData {
  new_coupon_code?: string;
  new_paywall_price_id: string;
}

const previewPriceChange = (subscriptionId: string, data: PriceChangeData) =>
  reactQueryPost(
    internalApi.communityMemberSubscriptionPriceChanges.preview({
      subscriptionId,
    }),
    data,
  );

const createPriceChange = (subscriptionId: string, data: PriceChangeData) =>
  reactQueryPost(
    internalApi.communityMemberSubscriptionPriceChanges.create({
      subscriptionId,
    }),
    data,
  );

export const communityMemberSubscriptionPriceChangesApi = {
  previewPriceChange,
  createPriceChange,
};
